import { ArrowDown, ArrowUpRight, Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { copyText } from '../lib/copyText';
import { SectionNode } from './SectionNode';

export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL;
if (!CONTACT_EMAIL) throw new Error('REACT_APP_CONTACT_EMAIL must be configured.');

export const Wordmark = ({ id, tagline = true, size = 'default' }) => (
  <span className={`wordmark-lockup wordmark-${size}`}>
    <span className="wordmark" aria-label="3tched, pronounced etched" data-testid={`${id}-wordmark`}><span className="wordmark-three" aria-hidden="true">3</span><span aria-hidden="true">tched</span></span>
    {tagline && <span className="wordmark-tagline" data-testid={`${id}-tagline`}>Etched in schema</span>}
  </span>
);

export const ContactButton = ({ id, outline = false, className = '', label = 'Start a conversation' }) => (
  <Button asChild variant={outline ? 'outline' : 'default'} className={`contact-button ${outline ? 'contact-outline' : ''} ${className}`}>
    <a href={`mailto:${CONTACT_EMAIL}`} data-testid={id}>{label} <ArrowUpRight size={16} aria-hidden="true" /></a>
  </Button>
);

export const SectionLabel = ({ number, children, id, heading }) => (
  <div className="section-label-row">
    <h2 className="section-label mono" data-testid={`${id}-section-label`}><span>{number}</span><span className="section-slash">/</span>{children}</h2>
    {heading && <SectionNode id={id} heading={heading} />}
  </div>
);

export const SectionConclusion = ({ id, children }) => (
  <p className="section-conclusion" data-testid={`${id}-conclusion`}>{children}</p>
);

export const DownloadLink = ({ href, children, id, className = '' }) => (
  <a className={`text-link ${className}`} href={href} download data-testid={id}>{children}<ArrowDown size={15} aria-hidden="true" /></a>
);

export const EmailCopy = () => {
  const copy = async () => {
    if (await copyText(CONTACT_EMAIL)) {
      toast.success(<span data-testid="email-copy-success">Email copied to clipboard</span>, { id: 'email-copy' });
    } else {
      toast.error(<span data-testid="email-copy-error">Couldn’t copy. Please use the email link instead.</span>, { id: 'email-copy' });
    }
  };
  return <Button variant="ghost" size="icon" className="copy-button" onClick={copy} aria-label="Copy contact email" data-testid="copy-contact-email"><Copy size={14} aria-hidden="true" /></Button>;
};